import api from '@/services/Api';
import moment from 'moment';
import { ActionContext, Module } from 'vuex';
import { EmailsState, RootState } from '@/store/types';
import { toastSwal } from '@/helper/swals';

export type ResendEmailsPayload = { emails: number[] };

type Context = ActionContext<EmailsState, RootState>;

export const emails: Module<EmailsState, RootState> = {
    namespaced: true,
    state: {
        filter: {
            zeitraum: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
        },
        loaders: {
            sending: false,
        },
    },
    actions: {
        resendEmails({ commit }: Context, payload: ResendEmailsPayload): void {
            commit('setLoadersSending', true);

            api.post('logs/emails/resend', payload)
                .then((response) => {
                    const sent = response.data.body;
                    const toSend = payload.emails.length;
                    const success = sent === toSend;

                    toastSwal(
                        success ? 'success' : 'warning',
                        'Emails',
                        `${sent} von ${toSend} gesendet`,
                        success ? 3000 : 6000);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSending', false));
        },
    },
    mutations: {
        setLoadersSending(state: EmailsState, loading: boolean): void {
            state.loaders.sending = loading;
        },
    },
};
